import { ApiBaseRequest } from './api-base-request';
import { ApiRequestOptions } from './api-request-options';
import { ApiParameters } from './api-parameters';

export abstract class ApiGetRequest extends ApiBaseRequest
{
    /**
     * @param service the name of the api service to connect with.
     * @param parameters instance of ApiParameters to use for query parameter.
     * @param options
     * @param endpoint override default api endpoint.
     */
    public constructor(
        service: string,
        parameters: ApiParameters = undefined,
        options: ApiRequestOptions = undefined,
        endpoint: string = undefined)
    {
        super(service, parameters, options, endpoint);
    }
}
